<template>
  <div class="pageIndex paddingbottom50 setHeightFullGrey">
    <van-sticky>
      <van-search class="search" background="#fec645" v-model="searchValue" placeholder="活动名称" shape="round" clearable
        @search="onSearch" right-icon="search">
        <van-icon slot="left-icon" name="location-o" color="#fab13e"></van-icon>
        <div @click="showCities()" slot="label" style="color: #fab13e;">{{ site }}站</div>
      </van-search>
    </van-sticky>

    <!-- <van-swipe v-show="imgs.length>0" :autoplay="150000" :show-indicators="false">
				<van-swipe-item  v-for="(item, index) in imgs" :key="index" @click="gourl(item.goto_url)">
					<div class="fixImage">
						<img :src="item.img_url" style="object-fit:scale-down ;vertical-align:bottom" alt="">
						<div class="swipeWord">{{item.name}}</div>
					</div>
				</van-swipe-item>
			</van-swipe> -->

    <van-grid :column-num="3" clickable :border="false" class="marginBottomXm" style="padding-top: 50px;">
      <van-grid-item v-for="(value, index) in menu" :key="index" :icon="value.icon" @click="chooseThis(value.title)">
        <span slot="text" v-if="value.selected" style="color: #fab13e;padding-top: 2px;">{{ value.title }}</span>
        <span slot="text" v-else style="color:#333;padding-top: 2px;">{{ value.title }}</span>
      </van-grid-item>
    </van-grid>
    <active :search="searchValue" :type="filter" :city="site"></active>
    <!-- 底部tab -->
    <myFoot></myFoot>
    <!-- 返回顶部 -->
    <backTop ref="bt"></backTop>

    <!-- <div @click="showCities()" data-target="ChooseModal" style="position: fixed;right: 5%;bottom: 18%;">
			<div class="" style="width:35px;height: 35px;color:white;border-radius:  35px; background:#0081FF;padding: 5px;text-align: center;line-height: 35px;">
				{{site}}
			</div>
		</div> -->

    <!-- 选择城市站点 -->
    <Subsite ref="subsite" :siteDetail="site" @onSelected="selectCity"></Subsite>
  </div>
</template>

<script>
import active from '../publicComponents/active.vue'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    active: active,
  },
  computed: {
    ...mapState(['site']),
  },
  data () {
    return {
      menu: [
        {
          title: '全部活动',
          icon: require('../../assets/static/secondmenu/jtdz.png'),
          to: '/filter?type=全部活动',
          selected: true,
        },
        {
          title: '日常活动',
          icon: require('../../assets/static/secondmenu/zhoumo.png'),
          to: '/filter?type=日常活动',
          selected: false,
        },
        {
          title: '假期活动',
          icon: require('../../assets/static/secondmenu/chunxia.png'),
          to: '/filter?type=假期活动',
          selected: false,
        },
      ],
      filter: '全部活动',
      option: [
        { text: '全部活动', value: '全部活动' },
        { text: '日常活动', value: '日常活动' },
        { text: '假期活动', value: '假期活动' },
      ],
      searchValue: '',
      radio: [],
      defaultSite: 0,
      joyPageStatus: '',
      imgs: [],
      type: '',
      class: '',
    }
  },

  created () {
    // this.loadSite();
    // this.loadBanner();
    let city = this.$route.query.city
    if (city) {
      this.$store.commit('ChangeSite', city)
    } else if (localStorage.site) {
      let city = localStorage.site
      this.$store.commit('ChangeSite', city)
    } else {
      this.$store.state.site = '杭州'
    }
    this.wxShare()
  },
  activated () {
    let city = this.$route.query.city
    if (city) {
      this.$store.commit('ChangeSite', city)
    } else if (localStorage.site) {
      let city = localStorage.site
      this.$store.commit('ChangeSite', city)
    } else {
      this.$store.state.site = '杭州'
    }
  },
  methods: {
    chooseThis (title) {
      this.filter = title
      for (let i in this.menu) {
        if (this.menu[i].title == title) {
          this.menu[i].selected = true
        } else {
          this.menu[i].selected = false
        }
      }
    },
    onSearch (value) {
      this.searchValue = value
    },
    selectCity (val) {
      console.log(val, 'val')
      this.$store.commit('ChangeSite', val)
    },
    showCities () {
      this.$refs.subsite.show()
    },
    // 跳转新页面
    gourl (item) {
      // location.href = item;
      window.open(item, '_blank')
    },
    loadBanner () {
      // 读取banner图
      try {
        this.$axios.get('banner/index?site=' + this.site).then((response) => {
          let data = response.data.data
          if (data.length > 0) {
            this.imgs = []
            for (var i = 0; i < data.length; i++) {
              data[i].img_url =
                'http://img.jiarixiaodui.com/' +
                data[i].img_url +
                '?x-oss-process=image/resize,m_fill,h_180,w_400'
              this.imgs.push(data[i])
            }
          } else {
            this.imgs = []
          }
        })
      } catch (e) {
        if (this.$Util.debug) {
          console.log(e)
        }
      }
    },
  },
}
</script>
<style>
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
</style>
<style scoped="scoped">
.setHeightFullGrey .search {
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
}

.bg-orange {
  background: #fab13e;
}

.swipeWord {
  color: #fff;
  font-size: 14px;
  position: initial;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0.3;
  width: 100%;
  height: 20px;
  overflow: hidden;
  text-align: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.fixImage {
  font-size: 0px;
  display: block;
  position: relative;
  overflow: hidden;
  z-index: 999;
  margin: 0 auto;
  margin-top: 10px;
  width: 95%;
  border-radius: 10px;
}
</style>
